import React from 'react';
import {
    BrowserRouter as Router,
    Route,
    Redirect
} from 'react-router-dom'

/*CSS*/
import 'onsenui/css/onsenui.css';
import 'onsenui/css/onsen-css-components.css';
import './App.css';

/*Components*/
import Header from './Components/GameHeader';
import Footer from './Components/GameFooter';

/*Pages*/
import GameMainPage from './Pages/GameMainPage';
import PressKit from './Pages/PressKit';
import EULA from './Pages/EULA';
import Policy from './Pages/Policy';
import DiscordPolicy from './Pages/DiscordPolicy';

//const server = require('./server');
//server.initialize();

class App extends React.Component {
    
    render() {
        return (
            <Router>
                <div className="App">
                    <Header />

                    <Route exact path='/' component={GameMainPage} />
                    <Route exact path='/Content-Creators' render={() => <Redirect to='/Press-Kit' />} />
                    <Route exact path='/Press-Kit' component={PressKit} />
                    <Route exact path='/EULA' component={EULA} />
                    <Route exact path='/Policy' component={Policy} />
                    <Route exact path='/discord/policy' component={DiscordPolicy} />

                    {/* Anomalies console store URLs have not been configured. */}
                    <Route exact path='/ps5' render={() => <Redirect to='/' />} />
                    <Route exact path='/xbox' render={() => <Redirect to='/' />} />

                    <Footer />

                </div>
            </Router>

        );
    }
}


export default App;
